import exercise1 from './i18n/exercise1';
import exercise2 from './i18n/exercise2';
import exercise3 from './i18n/exercise3';
import exercise4 from './i18n/exercise4';
import exercise5 from './i18n/exercise5';
import exercise6 from './i18n/exercise6';
import exercise7 from './i18n/exercise7';
import exercise8 from './i18n/exercise8';
import exercise9 from './i18n/exercise9';
import exercise10 from './i18n/exercise10';
import exercise11 from './i18n/exercise11';
import exercise12 from './i18n/exercise12';
import CourseController from "../../../../../components/diagrams/course.controller";

class UnearthingEmbeddedArgumentsController extends CourseController {

  constructor(helperService, $sce, courseService, $scope) {
    "ngInject";
    super(courseService, helperService, $sce, $scope);
    Object.assign(this, { courseService, helperService, $sce });
    this.videoUrl = this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322207695');

    this.lang = 'en';
    this.exercise1 = exercise1[this.lang];
    this.exercise2 = exercise2[this.lang];
    this.exercise3 = exercise3[this.lang];
    this.exercise4 = exercise4[this.lang];
    this.exercise5 = exercise5[this.lang];
    this.exercise6 = exercise6[this.lang];
    this.exercise7 = exercise7[this.lang];
    this.exercise8 = exercise8[this.lang];
    this.exercise9 = exercise9[this.lang];
    this.exercise10 = exercise10[this.lang];
    this.exercise11 = exercise11[this.lang];
    this.exercise12 = exercise12[this.lang];
    this.isUnit = true
    this.exerciseIdsStart = ''
  }
}

export default UnearthingEmbeddedArgumentsController;



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/deductiveReasoning.controller.js